import { getContext, invoke } from './core';
import { bridgeConfigDelegates } from './bridge-config-delegates';
import { fetchProduct } from './fetchProduct';

export const bridgeMethods = {
	...bridgeConfigDelegates,
	// Core methods
	getContext,
	invoke,
	fetchProduct,
};
